<template>
  <b-card no-body>
    <el-table
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="data"
    >
      <el-table-column type="expand" >
        <template slot-scope="props" v-if="props.row.catecumenos && props.row.catecumenos.length > 0">
          <el-table :data="props.row.catecumenos">
            <el-table-column prop="id" label="id" width="180" />
            <el-table-column prop="nombre" label="nombre" width="180" />
            <el-table-column label="apellidos" width="180">
              <template v-slot="{ row }">
                <div>{{ row.apellido1 + " " + row.apellido2 }}</div>
              </template></el-table-column
            >
          </el-table>
        </template>
      </el-table-column>
      <el-table-column sortable label="ID" prop="name">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{ row.id }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="Nombre y Apellidos"
        min-width="150px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.nombre + " " + row.apellido1 + " " + row.apellido2
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column sortable label="Telefono" min-width="150px" prop="date">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.telefono
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="Fecha Nacimiento"
        min-width="150px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                fecha_nacimiento(row.fecha_nacimiento)
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column sortable label="profesion" min-width="150px" prop="date">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.profesion
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column label="Editar" min-width="100px" prop="date">
        <template v-slot="{ row }">
          <b-row v-if="row.editable != false">
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-edit"
                circle
                @click="editarPadre(row.id)"
              ></el-button
            ></b-col>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-delete"
                circle
                @click="eliminarPadre(row.id, row.nombre + ' ' + row.apellido1 + ' ' + row.apellido2)"
              ></el-button
            ></b-col>
          </b-row>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>
<script>
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  data() {
    return {
      currentPage: 1,
    };
  },
  props: ["data", "tipoProgenitor"],
  methods: {
    editarPadre(id) {
      this.$emit("editarPadre", id);
    },
    eliminarPadre(id, nombre) {
      swal
        .fire({
          text: `¿Desea elimiar a ${nombre}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f5365c",
          cancelButtonColor: "#616365",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.$emit("eliminarPadre", id);
          }
        });
    },

    fecha_nacimiento(fecha) {
      if (fecha) {
        return fecha.split("-").reverse().join("/");
      }
    },
  },
};
</script>
<style scoped>
.separador {
  border-left: 1px solid rgb(2, 2, 2);
  height: auto;
}
</style>
